module.exports = __webpack_public_path__ + "img/option-3-preview.6d619467.webp";